module.exports = __webpack_public_path__ + "static/couple-watching-sunset-mobile.edb44c4f.webp";